/* src/app/routes.js */

/*
 * List of icons and associated text for sidebar content
 */

import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CourseApprIcon from '@material-ui/icons/ThumbsUpDown';
import InterviewIcon from '@material-ui/icons/Schedule';
import StudentIcon from '@material-ui/icons/Face';
import TutorIcon from '@material-ui/icons/Group';
import LessonIcon from '@material-ui/icons/Event';
import CourseIcon from '@material-ui/icons/School';
import UniversityIcon from '@material-ui/icons/AccountBalance';
import LocationIcon from '@material-ui/icons/LocationCity';
import MessageIcon from '@material-ui/icons/Message';
import AnnouncementIcon from '@material-ui/icons/Send';
import RequestsIcon from '@material-ui/icons/NotificationsActive';
import DiscountsIcon from '@material-ui/icons/AttachMoney';
import PersonAdd from '@material-ui/icons/PersonAdd';
import BuildIcon from '@material-ui/icons/Build';
import SubsidyIcon from '@material-ui/icons/MonetizationOn';
import History from '@material-ui/icons/History';
import { loadTexts } from '../config/texts';
import { Scenes } from '../modules';

const getLocale = () => {
  const lang = navigator.language || navigator.userLanguage;
  if (lang.includes('fr')) {
    return 'fr'
  }
  return 'en'
};

const TEXT_KEY = 'sidebar';

const texts = loadTexts(TEXT_KEY, getLocale());

export default [
  {
    path: '/dashboard',
    icon: DashboardIcon,
    text: texts.dashboard,
    scene: Scenes.Dashboard,
    ready: true,
  },
  // {
  //   path: '/interviews',
  //   icon: InterviewIcon,
  //   text: 'Interviews',
  //   scene: Scenes.Interviews,
  //   ready: true,
  // },
  {
    path: '/students',
    icon: StudentIcon,
    text: texts.students,
    scene: Scenes.Students,
    ready: true,
  },
  {
    path: '/tutors',
    icon: TutorIcon,
    text: texts.tutors,
    scene: Scenes.Tutors,
    ready: true,
  },
  {
    path: '/course_approvals',
    icon: CourseApprIcon,
    text: texts.course_approvals,
    scene: Scenes.CourseApprovals,
    ready: true,
  },
  {
    path: '/create_tutor',
    icon: PersonAdd,
    text: texts.create_tutors,
    scene: Scenes.CreateTutor,
    ready: true,
  },
  {
    path: '/lessons',
    icon: LessonIcon,
    text: texts.lessons,
    scene: Scenes.Lessons,
    ready: true,
  },
  {
    path: '/courses',
    icon: CourseIcon,
    text: texts.courses,
    scene: Scenes.Courses,
    ready: true,
  },
  // {
  //   path: '/universities',
  //   icon: UniversityIcon,
  //   text: 'Universities',
  //   scene: Scenes.Universities,
  //   ready: false,
  // },
  {
    path: '/locations',
    icon: LocationIcon,
    text: texts.locations,
    scene: Scenes.Locations,
    ready: true,
  },
  {
    path: '/user_support',
    icon: MessageIcon,
    text: texts.user_support,
    scene: Scenes.Messages,
    ready: true,
  },
  {
    path: '/announcement',
    icon: AnnouncementIcon,
    text: texts.announcement,
    scene: Scenes.Announcement,
    ready: true,
  },
  {
    path: '/notification',
    scene: Scenes.Notification,
    ready: true,
    omit: true,
    text: texts.notification,
  },
  // {
  //   path: '/requests',
  //   icon: RequestsIcon,
  //   text: texts.requests,
  //   scene: Scenes.Requests,
  //   ready: true,
  // },
  {
    path: '/discount',
    icon: DiscountsIcon,
    text: texts.discount,
    scene: Scenes.Discounts,
    ready: true,
  },
  {
    path: '/subsidy',
    icon: SubsidyIcon,
    text: texts.credited_program,
    scene: Scenes.Subsidy,
    ready: true,
  },
  {
    path: '/credited_history',
    icon: History,
    text: texts.credited_history,
    scene: Scenes.CreditedHistory,
    ready: true,
  },
  {
    path: '/survey',
    icon: AssignmentIcon,
    scene: Scenes.Survey,
    ready: true,
    text: texts.survey,
  },
  {
    path: '/organization',
    icon: BuildIcon,
    text: texts.service_settings,
    scene: Scenes.Organization,
    ready: true,
  },
];



// WEBPACK FOOTER //
// ./src/app/routes.js